import {
  eye,
  outlineuser,
  moneynofound,
  switchOn,
  banswitchoff,
  totalusers,
  totalMatchrooms,
} from '@assets/icons'
import Analytic from '@commons/cards/analytic'
import Grid from '@components/grid'
import Table from '@components/table'
import { Fragment } from 'react/jsx-runtime'

import { useNavigate } from 'react-router-dom'
import Column from '@components/column'
import Title from '@components/title'
import { useSelector } from 'react-redux'
import { RootState } from '@store/index'
import { User } from '@apis/index'
import { useEffect, useState } from 'react'
import { TableHeaderProps } from '@components/table/types'
import {
  BanSubtitle,
  BanTitle,
  CreatedByWrapper,
  MatchDateTimeWrapper,
  Name,
  Number,
  outline,
  ProfilePreview,
  ProfileWrapper,
  StatusWrapper,
  UserDetails,
} from './style'
import Svg from '@components/svg'
import { format } from 'date-fns'
import { useModal } from '@context/ModalContext'
import Button from '@components/button'
import Row from '@components/row'
import styled from '@emotion/styled'
import theme from '@utils/theme'
import { Helper } from '@utils/index'
import DashboardCard from '@commons/cards/dashboard'
import { Form, Formik } from 'formik'
import Fields from '@components/fields'
import DropDown from '@components/fields/dropdown'

const cardConfig = [
  {
    key: 'totalUsers',
    title: 'Total Users',
    icon: totalusers,
    isUp: true,
    link: '/admin/user-management',
  },
  {
    key: 'dailyActiveUser',
    title: 'Daily Active Users',
    icon: totalusers,
    isUp: true,
    link: '/admin/game-management/match-rooms',
  },
  {
    key: 'totalMatchesCreatedByUser',
    title: 'Player Created Matchroom',
    icon: totalMatchrooms,
    isUp: false,
    link: '/admin/game-management/match-results?tab=Player Created',
  },
  {
    key: 'totalMatchesOnGoing',
    title: 'Active Matchrooms',
    icon: totalMatchrooms,
    isUp: false,
    link: '/admin/game-management/match-results?tab=Admin Created',
  },
]

const UserManagement = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const { showModal } = useModal()
  const navigate = useNavigate()
  const {
    items: users,
    loading,
    totalItems,
    totalPages,
  } = useSelector((state: RootState) => state.users)
  const [page, setPage] = useState(1)
  console.log('users', users)
  // State for fine history modal
  const [fineHistoryData, setFineHistoryData] = useState({
    items: [],
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    loading: false,
  })

  const fetchUsers = async (search = '', page = 1) => {
    try {
      await User.list({
        state: 'users',
        params: { page, limit: 30, search },
      })
    } catch (error) {}
  }

  const fetchFineOrWarn = async (userId: number, page = 1, limit = 10) => {
    try {
      setFineHistoryData((prev) => ({ ...prev, loading: true }))
      const res = await User.findfineorwarn({
        state: 'u',
        params: { userId, page, limit },
      })

      console.log('Fine history response:', res)

      if (res) {
        setFineHistoryData({
          items: res.items || [],
          totalItems: res.totalItems || 0,
          totalPages: res.totalPages || 1,
          currentPage: res.page || page,
          loading: false,
        })

        showModal(
          <FineOrWarnListModal
            fines={res.items || []}
            totalItems={res.totalItems || 0}
            totalPages={res.totalPages || 1}
            currentPage={res.page || page}
            userId={userId}
            onPageChange={(newPage) => fetchFineOrWarn(userId, newPage)}
            loading={false}
          />,
          {
            width: '90%',
          },
        )
      }
    } catch (err) {
      console.error('Error fetching fine/warn data:', err)
      setFineHistoryData((prev) => ({ ...prev, loading: false }))
      showModal(<FineOrWarnListModal fines={[]} />)
    }
  }

  const columns: TableHeaderProps[] = [
    {
      title: 'S.N',
      key: 'sn',
      render: (item, index) => item.id,
    },
    {
      title: 'Full Name',
      key: 'fullName',
      render: (item) => (
        <CreatedByWrapper>
          <ProfileWrapper
            bgcolor={Helper.getDynamicColor(item.fullName || item.email || '')}
          >
            {item.avatar ? (
              <ProfilePreview
                src={`https://admin.tournaop.com//${item.avatar}`}
              />
            ) : (
              <p>{item.fullName[0]}</p>
            )}
          </ProfileWrapper>
          <UserDetails>
            <Name>{item?.fullName}</Name>
            <Number>{item?.phone}</Number>
          </UserDetails>
        </CreatedByWrapper>
      ),
    },
    {
      title: 'Email',
      key: 'email',
      render: (item) => <span>{item?.email}</span>,
    },
    {
      title: 'Points',
      key: 'points',
      render: (item) => <span>{item?.points} points</span>,
    },
    {
      title: 'Store Points',
      key: 'storePoints',
      render: (item) => <span>{item?.storePoints} points</span>,
    },

    {
      title: 'Created on',
      key: 'createdOn',
      render: (item) => (
        <MatchDateTimeWrapper>
          <p>{item.createdOn?.date}</p>
          <p>{item.createdOn?.time}</p>
        </MatchDateTimeWrapper>
      ),
    },
    {
      title: 'Ban Status',
      key: 'status',
      render: (item) => (
        <StatusWrapper>
          <Svg
            src={item.status ? switchOn : banswitchoff}
            onClick={(e) => {
              e.stopPropagation()
              showModal(<BanUser item={item} />)
            }}
          />
        </StatusWrapper>
      ),
    },
    {
      title: 'Fine History',
      key: 'fineHistory',
      render: (item) => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            title="View"
            onClick={(e) => {
              e.stopPropagation()
              fetchFineOrWarn(item.id)
            }}
            height={32}
          />
        </div>
      ),
    },
  ]

  const data = users.map((user) => ({
    id: user.id,
    fullName: user.name,
    phone: user.phoneNo,
    email: user.email,
    points: user.points,
    createdOn: {
      date: format(new Date(user.createdAt), 'MMM do, yyyy'),
      time: format(new Date(user.createdAt), 'hh:mmaaa'),
    },
    status: user.isActive,
    avatar: user.avatar,
  }))

  useEffect(() => {
    setPage(1)
  }, [searchTerm])

  useEffect(() => {
    fetchUsers(searchTerm, page)
  }, [page, searchTerm])

  return (
    <Fragment>
      <Column>
        <DashboardCard cardConfig={cardConfig} />

        <Title textone="User" texttwo="Management" />
        <Table
          onSearchChange={(val) => {
            setSearchTerm(val)
          }}
          loading={loading}
          columns={columns}
          data={data}
          itemsPerPage={30}
          text="User List"
          icon={outlineuser}
          searchKeys={['email', 'number', 'name']}
          onPageChange={setPage}
          pageControlled={page}
          totalItems={totalItems}
          totalPages={totalPages}
          actions={[
            {
              icon: eye,
              onClick: (item) =>
                navigate(`/admin/user-management/${item.id}`, {
                  state: item.id,
                }),
              key: 'view',
            },
            {
              icon: moneynofound,
              onClick: (row, e) => {
                e.stopPropagation()
                showModal(<FineOrBan item={row} />)
              },
              key: 'moneynofound',
            },
          ]}
          onRowClick={(data) =>
            navigate(`/admin/user-management/${data.id}`, {
              state: data.id,
            })
          }
        />
      </Column>
    </Fragment>
  )
}

const BanUser = ({ item }: { item: any }) => {
  const { hideModal } = useModal()
  const isCurrentlyBanned = !item.status

  const title = isCurrentlyBanned ? 'Unban User' : 'Ban User'
  const subtitle = isCurrentlyBanned
    ? 'Are you sure you want to unban this user and restore access to the platform?'
    : 'Are you sure you want to ban this user from the platform?'

  const newStatus = isCurrentlyBanned ? true : false

  const handleConfirm = async () => {
    await User.update({
      id: item.id,
      data: { isActive: newStatus },
      state: 'users',
    }).then(() => {
      hideModal()
    })
  }

  return (
    <Fragment>
      <Column stylecolumn="gap:10px">
        <BanTitle>{title}</BanTitle>
        <BanSubtitle>{subtitle}</BanSubtitle>
        <Row styleRow="justify-content:center; gap:8px;width:100%;">
          <Button
            title="Cancel"
            justify="center"
            width={100}
            height={40}
            styleButton={outline}
            onClick={hideModal}
          />
          <Button
            title={`Confirm ${isCurrentlyBanned ? 'Unban' : 'Ban'}`}
            justify="center"
            width={100}
            height={40}
            onClick={handleConfirm}
          />
        </Row>
      </Column>
    </Fragment>
  )
}

const FineOrBan = ({ item }: { item: any }) => {
  const [initialState, setInitialState] = useState({
    type: '',
    number: item.phone,
    amount: '',
    description: '',
    walletType: 'points',
  })
  const [loading, setLoading] = useState(false)
  const { hideModal } = useModal()

  const handleSubmit = async (values) => {
    setLoading(true)
    try {
      const payload = {
        type: values.type,
        phoneNo: values.number,
        description: values.description,
        ...(values.type === 'Fine' && {
          amount: values.amount,
          walletType: values.walletType,
        }),
      }
      await User.fineOrWarn({
        id: item.id,
        data: payload,
        state: 'users',
      })
      hideModal()
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  return (
    <Fragment>
      <BanTitle>{'Fine User'}</BanTitle>
      <br />
      <br />
      <Formik
        initialValues={initialState}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values }: any) => (
          <Form>
            <Column stylecolumn="gap:10px">
              <Fields.PhoneInput
                label="Mobile Number"
                name="number"
                placeholder="Enter Mobile Number"
              />
              <div style={{ width: '95%' }}>
                <DropDown
                  label="Type"
                  name="type"
                  placeholder="Select Type"
                  valueAsKey="key"
                  titleAsKey="title"
                  styleWrapper="z-index:999999999"
                  options={[
                    { title: 'Fine', key: 'Fine' },
                    { title: 'Warning', key: 'Warning' },
                  ]}
                />
              </div>

              {values.type === 'Fine' && (
                <div style={{ width: '95%' }}>
                  <DropDown
                    label="Wallet Type"
                    name="walletType"
                    placeholder="Select Wallet Type"
                    valueAsKey="key"
                    titleAsKey="title"
                    styleWrapper="z-index:99999998"
                    options={[
                      { title: 'Main Wallet (Points)', key: 'points' },
                      {
                        title: 'Store Wallet (Store Points)',
                        key: 'storePoints',
                      },
                    ]}
                  />
                </div>
              )}

              <Fields.Input
                label="Fine Amount"
                name="amount"
                placeholder="Enter Amount"
                disabled={values.type !== 'Fine'}
              />

              <Fields.TextArea
                label="Description"
                name="description"
                placeholder="Enter Description"
              />
              <Button
                title={loading ? 'Loading...' : 'Submit'}
                justify="center"
                width={100}
                height={40}
                type="submit"
              />
            </Column>
          </Form>
        )}
      </Formik>
    </Fragment>
  )
}

const FineOrWarnListModal = ({
  fines,
  totalItems = 0,
  totalPages = 1,
  currentPage = 1,
  userId,
  onPageChange,
  loading = false,
}: {
  fines: any[]
  totalItems?: number
  totalPages?: number
  currentPage?: number
  userId?: number
  onPageChange?: (page: number) => void
  loading?: boolean
}) => {
  const { hideModal } = useModal()
  const [page, setPage] = useState(currentPage)

  const calculateDaysAgo = (dateString: string) => {
    const diffMs = new Date().getTime() - new Date(dateString).getTime()
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))
    return diffDays <= 0
      ? 'Today'
      : `${diffDays} day${diffDays > 1 ? 's' : ''} ago`
  }

  const getTypeColor = (type: string) => {
    const typeLower = type.toLowerCase()
    if (typeLower.includes('fine')) return '#dc2626'
    if (typeLower.includes('warning')) return '#f59e0b'
    return '#6b7280'
  }

  const handlePageChange = (newPage: number) => {
    setPage(newPage)
    if (onPageChange && userId) {
      onPageChange(newPage)
    }
  }

  const fineColumns: TableHeaderProps[] = [
    {
      title: 'S.N',
      key: 'sn',
      render: (item, index) => (page - 1) * 10 + index + 1,
    },
    {
      title: 'Type',
      key: 'type',
      render: (item) => (
        <div
          style={{
            padding: '4px 12px',
            backgroundColor: getTypeColor(item.type) + '15',
            color: getTypeColor(item.type),
            borderRadius: '20px',
            fontSize: '12px',
            fontWeight: 600,
            border: `1px solid ${getTypeColor(item.type)}20`,
            display: 'inline-block',
          }}
        >
          {item.type}
        </div>
      ),
    },
    {
      title: 'Amount',
      key: 'amount',
      render: (item) =>
        item.amount ? (
          <span style={{ fontWeight: 700, color: '#dc2626' }}>
            Rs {item.amount}
          </span>
        ) : (
          <span style={{ color: theme.colors.textSecondary }}>-</span>
        ),
    },
    {
      title: 'Wallet Type',
      key: 'walletType',
      render: (item) =>
        item.type === 'Fine' ? (
          <span style={{ fontWeight: 600, color: theme.colors.text }}>
            {item.walletType === 'storePoints' ? 'Store Points' : 'Points'}
          </span>
        ) : (
          <span style={{ color: theme.colors.textSecondary }}>-</span>
        ),
    },
    {
      title: 'Description',
      key: 'description',
      render: (item) => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.4' }}>
            {item.description}
          </p>
        </div>
      ),
    },
    {
      title: 'Date',
      key: 'date',
      render: (item) => (
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '14px', fontWeight: 600 }}>
            {format(new Date(item.createdAt), 'MMM dd, yyyy')}
          </div>
          <div style={{ fontSize: '12px', color: theme.colors.textSecondary }}>
            {calculateDaysAgo(item.createdAt)}
          </div>
        </div>
      ),
    },
  ]

  const fineData = fines.map((fine) => ({
    ...fine,
    id: fine.id,
  }))

  return (
    <Fragment>
      <div style={{ padding: '20px', minWidth: '800px' }}>
        {/* Header */}
        <div
          style={{
            textAlign: 'center',
            marginBottom: '20px',
            borderBottom: `1px solid ${theme.colors.border}`,
            paddingBottom: '16px',
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: '24px',
              fontWeight: 600,
              color: theme.colors.text,
            }}
          >
            User Fine & Warning History
          </h2>
          <p
            style={{
              margin: '4px 0 0 0',
              color: theme.colors.textSecondary,
              fontSize: '14px',
            }}
          >
            {totalItems} record{totalItems !== 1 ? 's' : ''} found
          </p>
        </div>

        {/* Table */}
        <Table
          loading={loading}
          columns={fineColumns}
          data={fineData}
          itemsPerPage={10}
          text="Fine History"
          onPageChange={handlePageChange}
          pageControlled={page}
          totalItems={totalItems}
          totalPages={totalPages}
          hasSearchbar={false}
        />

        <div
          style={{
            marginTop: '20px',
            borderTop: `1px solid ${theme.colors.border}`,
            paddingTop: '16px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Button title="Close" onClick={hideModal} width={120} height={44} />
        </div>
      </div>
    </Fragment>
  )
}

export default UserManagement
